import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { PermissionCode } from '../user';
import { getPermission } from './query/usePermissionQuery';

export function useHasPermissionForVersion(): (
  defaultPermissionCode: PermissionCode,
  defaultVersionId: number,
) => boolean;
export function useHasPermissionForVersion(
  defaultPermissionCode: PermissionCode,
  defaultVersionId: number,
): boolean;
export function useHasPermissionForVersion(
  defaultPermissionCode?: PermissionCode,
  defaultVersionId?: number,
) {
  const [data, setData] = useState<boolean | undefined>(undefined);
  const paramsRef = useRef<{
    permissionCode?: PermissionCode;
    versionId?: number;
  }>({});

  const get = useCallback(
    (permissionCode: PermissionCode, versionId: number) => {
      if (
        paramsRef.current.permissionCode === permissionCode &&
        paramsRef.current.versionId === versionId
      ) {
        return;
      }

      paramsRef.current = { permissionCode, versionId };

      getPermission({ permissionCode, versionId }).then(setData);
    },
    [],
  );

  useEffect(() => {
    if (defaultPermissionCode !== undefined && defaultVersionId !== undefined) {
      get(defaultPermissionCode, defaultVersionId);
    }
  }, [defaultPermissionCode, defaultVersionId, get]);

  return useMemo(
    () =>
      defaultPermissionCode !== undefined && defaultVersionId !== undefined
        ? data
        : (permissionCode: PermissionCode, versionId: number) => {
            get(permissionCode, versionId);
            return data;
          },
    [defaultPermissionCode, defaultVersionId, get, data],
  );
}
